export default __webpack_public_path__ + "static/media/0xe8a05e85883f9663b18a38d7aa89853deaba56e3.5c1d7c2b.webp";